<script setup>
import Claims from "@/pages/Claims.vue"
import { useContextStore, useSearchStore } from "@/store";

useSearchStore().refreshKey();
</script>
<template>

  <div v-if="!(useContextStore().isPlatformBrowser)">
    <router-view></router-view>
  </div>
  <main v-if="useContextStore().isPlatformBrowser" class="relative z-0 flex-1 overflow-y-auto focus:outline-none">
    <!-- Start main area-->
    <div v-if="useSearchStore().searchKey" class="absolute inset-0 py-6 ">
      <Claims />
      <!-- <router-view></router-view> --> <!-- Mobile --> 
      <!-- <div class="h-full border-2 border-gray-200 border-dashed rounded-lg" /> -->
    </div>
    <!-- End main area -->
  </main>
  <aside v-if="useContextStore().isPlatformBrowser" class="relative flex-shrink-0 overflow-y-auto border-l border-gray-200 xl:flex">
    <!-- Start secondary column (hidden on smaller screens) -->
    <div class="absolute inset-0">
      <router-view></router-view>
    </div>
    <!-- End secondary column -->
  </aside>

</template>